module.exports = __webpack_public_path__ + "img/googleads.6691caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/googleads.png
// module id = WRb9
// module chunks = 39 44